import { classNames } from "helpers/commonHelpers";

interface FormSectionLabelProps {
  label: string;
  required?: boolean;
  supportingText?: string;
}

export default function FormSectionLabel({ label, required, supportingText }: FormSectionLabelProps) {
  return (
    <div className="rfv2-section-label">
      <span className={classNames("rfv2-section-label__title", { required })}>
        {label}
      </span>
      {supportingText && <span className="rfv2-section-label__supporting-text">{supportingText}</span>}
    </div>
  );
}
